/**CORE LIBRARIES IMPORT */
import React from "react";




const EventActivities = () => {

  return (
    <>
    </>
  );
};

export default EventActivities;
